export default "__VITE_ASSET__kNuBudBh__"